import { ReactElement } from 'react';
import { UserPermissions } from 'api/users/types';
import PermissionRoute from 'components/PermissionRoute';

export const WithPermission = (permission: keyof UserPermissions, element: ReactElement) => {
  return <PermissionRoute permission={permission}>{element}</PermissionRoute>;
};
